import { ModuleWithProviders, NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { PipesModule } from '../../pipes/pipes.module';
import { AlphaScroll } from './alpha-scroll';


export class AlphaScrollModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: AlphaScrollModule, providers: []
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    IonicModule,
    PipesModule
  ],
  exports: [
    AlphaScroll
  ],
  declarations: [
    AlphaScroll
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
